import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import ActionsLog from "../../../../components/common/ActionsLog";
import Texts from "../../../../components/common/Texts";
import Emails from "../../../../components/common/Emails";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import NewWorkOrder from "./components/NewWorkOrder";

import { Card, Col, Collapse, Dropdown, Row } from "antd";

import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdModeEditOutline,
  MdOutlineAdd,
} from "react-icons/md";

import { BsThreeDots } from "react-icons/bs";
import { FaCheck, FaRegEdit, FaRegMoneyBillAlt } from "react-icons/fa";
import { RiDeleteBin6Line, RiArrowUpSLine } from "react-icons/ri";
import {
  AiFillPrinter,
  AiOutlineNotification,
  AiOutlineClockCircle,
} from "react-icons/ai";
import { IoIosText } from "react-icons/io";
import { CgClose } from "react-icons/cg";
import { MdOutlineMail } from "react-icons/md";
import { TbSquareCheck, TbDots } from "react-icons/tb";

import "./WorkOrderDetails.css";
import CollpaseContainer from "../../../../components/common/CollapseContainer";

import { estimateMenu } from "../../../../utils/workOrder";
import NotifyOwner from "./components/NotifyOwner";
import NotifyTenant from "./components/NotifyTenant";
import Schedule from "./components/Schedule";
import MarkJobDone from "./components/MarkJobDone";
import Waiting from "./components/Waiting";
import Cancel from "./components/Cancel";
import CreateBill from "./components/CreateBill";
import Email from "./components/Email";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";

const WorkOrderDetailsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod(
      "New Service Request",
      "1",
      "",
      "",
      "/maintenance/work-orders/service-requests/new"
    ),
    RightBarMethod(
      "New Recurring Work Order",
      "2",
      "",
      "",
      "/maintenance/recurring-work-orders/new"
    ),
    RightBarMethod("New Purchase Order", "3", "", "", ""),
  ]),
  RightBarMethod(
    "REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Work Order", "4", "", "", "/"),
      RightBarMethod("Association Work Order", "5", "", "", "/"),
      RightBarMethod("Work Order Labor Summary", "6", "", "", "/"),
    ]
  ),
  RightBarMethod(
    "HELP TOPICS",
    "t3",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod("Vendor Portal Overview", "7", "", "", "/"),
      RightBarMethod("Texting On Work Order", "8", "", "", "/"),
      RightBarMethod("Notifications and Tracking", "9", "", "", "/"),
    ]
  ),
];

function WorkOrderDetails() {
  const [collapse, setCollapse] = useState(false);
  const [addWorkOrder, setAddWorkOrder] = useState(false);
  const [workOrderDetails, setWorkOrderDetails] = useState({});
  const [workOrderNumber, setWorkorkOrderNumber] = useState("");
  const [vendor, setVendor] = useState({});
  const [notifyOwner, setNotifyOwner] = useState(false);
  const [notifyTenant, setNotifyTenant] = useState(false);
  const [schedule, setSchedule] = useState(false);
  const [markJobDone, setMarkJobDone] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [cancelEdit, setCancelEdit] = useState(false);
  const [editId, setEditId] = useState(0);
  const [email, setEmail] = useState(false);
  const [estimatesRequest, setEstimatesRequest] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [workOrderData, setWorkOrderData] = useState({});
  const { id } = useParams();

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            console.log("res", res);
            setCompanyName(res.companyName);
          });
          setIsCompanyNameFetched(true);
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const fetchWorkOrders = async () => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const newServiceRequestRef = doc(companyDocRef, "workOrders", id);

      const docSnap = await getDoc(newServiceRequestRef);

      if (docSnap.exists()) {
        console.log("Document data:", docSnap.data());
        setWorkOrderData({ ...docSnap.data(), docId: docSnap.id });
      } else {
        console.log("No such document!");
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchWorkOrders();
    console.log("helllo I am from useEffect");
  }, [companyName, isCompanyNameFetched]);

  const navigate = useNavigate();
  const [itemData, setItemData] = useState({});

  const setEditData = (item) => {
    setEdit(true);
    setEditId(item.id);
    setItemData(item);
  };

  const sendEmail = (item) => {
    setEmail(true);
    setWorkorkOrderNumber(item.workOrderNumber);
  };

  // useEffect(() => {
  //   const newObj = tableAllData.find((item) => {
  //     return item.id === Number(id);
  //   });
  //   setWorkOrderDetails(newObj);
  // }, []);

  console.log("workOrderData", workOrderData);
  const items = [
    {
      label: "Enter Estimates",
      key: "1",
      icon: <FaRegEdit size={18} />,
    },
    {
      label: "Notify Owner",
      key: "2",
      icon: <AiOutlineNotification size={18} />,
    },
    {
      label: "Notify Tenant",
      key: "3",
      icon: <AiOutlineNotification size={18} />,
    },
    {
      label: "Schedule",
      key: "4",
      icon: <AiOutlineClockCircle size={18} />,
    },
    {
      label: "Mark Job Done",
      key: "5",
      icon: <TbSquareCheck size={18} />,
    },
    {
      label: "Create Bill",
      key: "6",
      icon: <FaRegMoneyBillAlt size={18} />,
    },
    {
      label: "Waiting",
      key: "7",
      icon: <TbDots size={18} />,
    },
    {
      label: "Cancel",
      key: "8",
      icon: <CgClose size={18} />,
    },
  ];

  const handleMenuClick = (e) => {
    console.log("click", e);
    if (e.key === "2") {
      setNotifyOwner(true);
    }
    if (e.key === "3") {
      setNotifyTenant(true);
    }
    if (e.key === "4") {
      setSchedule(true);
    }
    if (e.key === "5") {
      setMarkJobDone(true);
    }
    if (e.key === "6") {
      setIsModalOpen(true);
    }
    if (e.key === "7") {
      setWaiting(true);
    }
    if (e.key === "8") {
      setCancel(true);
    }
  };

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const setData = (item) => {
    setWorkorkOrderNumber(item.workOrderNumber);
    setVendor(item.vendor);
  };

  console.log("WorkOrder Data********", workOrderData);
  console.log("WorkOrder Data********", companyName);
  const [createdBy, setCreatedBy] = useState("");
  const [property, setProperty] = useState({});
  const [owner, setOwner] = useState({});
  const [tenant, setTenant] = useState({});

  const fetchUsers = async () => {
    try {
      const userRef = collection(db, "companies", companyName, "users");
      const snapShot = await getDocs(userRef);
      const fetchedData = snapShot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log("users", fetchedData);

      const filteredData = fetchedData.find(
        (item) => item.id === workOrderData.workOrderInformation.createdBy
      );
      console.log("user", filteredData);
      setCreatedBy(
        `${filteredData.profile.firstName} ${filteredData.profile.lastName}`
      );
    } catch (err) {
      console.error(err);
    }

    try {
      const userRef = collection(db, "companies", companyName, "properties");
      const snapShot = await getDocs(userRef);
      const fetchedData = snapShot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log("users", fetchedData);

      const filteredData = fetchedData.find(
        (item) => item.id === workOrderData.ownerInformation.propertyId
      );
      console.log("user", filteredData);
      setProperty(filteredData);
    } catch (err) {
      console.error(err);
    }

    try {
      const userRef = collection(db, "companies", companyName, "owners");
      const snapShot = await getDocs(userRef);
      const fetchedData = snapShot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log("owners", fetchedData);

      const filteredData = fetchedData.find(
        (item) => item.id === workOrderData.ownerAndFinancials.owners[0].ownerId
      );
      console.log("owner", filteredData);
      setOwner(filteredData);
    } catch (err) {
      console.error(err);
    }

    try {
      const userRef = collection(db, "companies", companyName, "tenants");
      const snapShot = await getDocs(userRef);
      const fetchedData = snapShot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      console.log("tenants", fetchedData);

      const filteredData = fetchedData.find(
        (item) => item.id === workOrderData.tenantId
      );
      console.log("tenant", filteredData);
      setTenant(filteredData);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (!isCompanyNameFetched) return;
    fetchUsers();
    console.log("helllo I am from useEffect");
  }, [companyName, isCompanyNameFetched, workOrderData]);

  return (
    <>
      <Row className="work-order-details" gutter={[0, 24]}>
        <Col span={24}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <Row justify="space-between">
                <Col>
                  <Row gutter={[16, 0]} align="middle">
                    <Col>
                      <p className="title-text">
                        Service Request #
                        {workOrderData?.workOrderInformation?.reqNumber}
                      </p>
                    </Col>
                    <Col>
                      <button className="edit-btn">
                        <MdModeEditOutline size={18} />
                        <span>Edit</span>
                      </button>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <span className="resident-text">Resident</span>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Card>
                <Row gutter={[0, 16]}>
                  <Col span={24}>
                    <Row>
                      <Col span={12}>
                        <strong>Description</strong>
                        <p>{workOrderData?.ownerInformation?.description}</p>
                      </Col>
                      <Col span={12}>
                        <p>
                          <strong>Created on: </strong>
                          {workOrderData?.workOrderInformation?.creationData}
                        </p>
                        <p>
                          <strong>Created by: </strong>
                          {createdBy ? createdBy : ""}
                        </p>
                        <p>
                          <strong>Priority: </strong>
                          {workOrderData?.ownerInformation?.priority}
                        </p>
                        <p>
                          <strong>Permission to enter: </strong>
                          {workOrderData?.ownerInformation?.permissionToEnter}
                        </p>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row className="work-order-info-container">
                      <Col span={8} className="col-container black-top">
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <p>Property</p>
                            <strong className="onclick-text">
                              {property?.propertyNameAddress
                                ? property?.propertyNameAddress?.propertyName
                                : "--"}
                            </strong>
                          </Col>
                          {collapse ? (
                            <>
                              <Col span={24}>
                                <p className="onclick-text">
                                  {workOrderData?.property
                                    ? workOrderData.property.propertyUnit
                                    : null}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Property Notes:</strong>
                                <p>
                                  {property?.notes?.length > 0
                                    ? property?.notes[0].text
                                    : "--"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Maintenance Limit:</strong>
                                <p>
                                  {property?.maintenanceInformation
                                    ?.maintenanceLimit
                                    ? property?.maintenanceInformation
                                        ?.maintenanceLimit
                                    : "--"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Home Warranty Company:</strong>
                                <p>
                                  {property?.maintenanceInformation
                                    ?.homeWarrantyCompany
                                    ? property?.maintenanceInformation
                                        ?.homeWarrantyCompany
                                    : "--"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Home Warranty Expires:</strong>
                                <p>
                                  {property?.maintenanceInformation
                                    ?.homeWarrantyExpiration
                                    ? property?.maintenanceInformation
                                        ?.homeWarrantyExpiration
                                    : "--"}
                                </p>
                              </Col>
                            </>
                          ) : null}
                        </Row>
                      </Col>
                      <Col
                        span={8}
                        className="owner-container col-container blue-top"
                      >
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <p>OWNER</p>
                            <strong className="onclick-text">
                              {owner?.ownerInfo
                                ? owner?.ownerInfo?.firstName +
                                  " " +
                                  owner?.ownerInfo?.lastName
                                : "--"}
                            </strong>
                          </Col>
                          {collapse ? (
                            <>
                              <Col span={24}>
                                <p className="onclick-text">
                                  {owner?.contact?.emails.length > 0
                                    ? owner?.contact?.emails[0].email
                                    : "--"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Owner Notes:</strong>
                                <p>
                                  {owner?.notes?.length > 0
                                    ? owner?.notes[0].text
                                    : "--"}
                                </p>
                              </Col>
                            </>
                          ) : null}
                        </Row>
                      </Col>
                      <Col span={8} className="col-container green-top">
                        <Row gutter={[0, 8]}>
                          <Col span={24}>
                            <p>RESIDENT</p>
                            <strong className="onclick-text">
                              {tenant?.profileInfo
                                ? tenant?.profileInfo?.firstName +
                                  " " +
                                  tenant?.profileInfo?.lastName
                                : "--"}
                            </strong>
                          </Col>
                          {collapse ? (
                            <>
                              <Col span={24}>
                                <p className="onclick-text">
                                  {tenant?.contact?.emails.length > 0
                                    ? tenant?.contact?.emails[0].email
                                    : "--"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Phone:</strong>
                                <p>
                                  {tenant?.contact?.phoneNumbers.length > 0
                                    ? tenant?.contact?.phoneNumbers[0]
                                        .phoneNumber
                                    : "--"}
                                </p>
                              </Col>
                              <Col span={24}>
                                <strong>Pets:</strong>
                                <p>
                                  {tenant?.pets.length > 0
                                    ? tenant?.pets[0].name
                                    : "--"}
                                </p>
                              </Col>
                            </>
                          ) : null}
                        </Row>
                      </Col>
                    </Row>
                    <Row justify="center">
                      <Col className="collapse-parent">
                        <button
                          className="collapse-btn"
                          onClick={() => setCollapse(!collapse)}
                        >
                          {" "}
                          {collapse ? (
                            <MdKeyboardArrowUp size={18} />
                          ) : (
                            <MdKeyboardArrowDown size={18} />
                          )}{" "}
                        </button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <Row>
                <Col>
                  <Row gutter={[16, 0]} align="middle">
                    <Col>
                      <p className="title-text">
                        {workOrderData?.relatedWorkOrders
                          ? workOrderData?.relatedWorkOrders.length
                          : null}
                        Work Orders
                      </p>
                    </Col>
                    <Col>
                      <button
                        className="add-btn"
                        onClick={() => setAddWorkOrder(true)}
                      >
                        <MdOutlineAdd size={18} />
                        <span>Add</span>
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            {workOrderData?.relatedWorkOrders
              ? workOrderData?.relatedWorkOrders.map((item, index) => {
                  return (
                    <>
                      {!edit || cancelEdit ? (
                        <Col span={24} key={index}>
                          <Row
                            justify="space-between"
                            className="work-order-actions"
                          >
                            <Col>
                              <span>Work Order #{item.workOrderNumber}</span>
                            </Col>
                            <Col>
                              <Row align="middle" gutter={[16, 0]}>
                                <Col>
                                  <Dropdown
                                    menu={menuProps}
                                    onClick={() => setData(item)}
                                    trigger={["click"]}
                                  >
                                    <button className="action-btn dropdown-action-btn">
                                      <span>Actions</span>
                                      <BsThreeDots size={18} />
                                    </button>
                                  </Dropdown>
                                </Col>
                                <Col>
                                  <button className="action-btn">
                                    <FaCheck size={18} />
                                    <span>Tracking</span>
                                  </button>
                                </Col>
                                <Col>
                                  <button
                                    className="action-btn"
                                    onClick={() => setEditData(item)}
                                  >
                                    <MdModeEditOutline size={18} />
                                    <span>Edit</span>
                                  </button>
                                </Col>
                                <Col>
                                  <button className="action-btn">
                                    <RiDeleteBin6Line size={18} />
                                    <span>Delete</span>
                                  </button>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          <Row className="work-order-content" gutter={[0, 16]}>
                            <Col span={24} className="col-container">
                              <Row justify="space-between">
                                <Col className="vertical-gap">
                                  <p className="title">Job Description</p>
                                  <p>{item.jobDescription}</p>
                                </Col>
                                <Col className="vertical-gap">
                                  <Row gutter={[8, 0]}>
                                    <Col>
                                      <button className="work-action-btn">
                                        <AiFillPrinter size={18} />
                                        <span>Print</span>
                                      </button>
                                    </Col>
                                    <Col>
                                      <button className="work-action-btn">
                                        <IoIosText size={18} />
                                        <span>Text</span>
                                      </button>
                                    </Col>
                                    <Col>
                                      <button
                                        className="work-action-btn"
                                        onClick={() => sendEmail(item)}
                                      >
                                        <MdOutlineMail size={18} />
                                        <span>Email</span>
                                      </button>
                                    </Col>
                                  </Row>
                                  <p>
                                    <strong>Owner approved:</strong>{" "}
                                    {item.ownerApproved ? "yes" : "No"}
                                  </p>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24}>
                              <CollpaseContainer
                                title="Estimates"
                                extras={
                                  <Row gutter={[8, 0]}>
                                    <Col>
                                      <Dropdown menu={estimateMenu}>
                                        <button className="work-action-btn">
                                          <span>Email Estimates</span>
                                          <RiArrowUpSLine size={18} />
                                        </button>
                                      </Dropdown>
                                    </Col>
                                    <Col>
                                      <button
                                        className="work-action-btn"
                                        onClick={() =>
                                          navigate(
                                            `/maintenance/work-orders/manage-estimates/${item.workOrderNumber}`
                                          )
                                        }
                                      >
                                        <IoIosText size={18} />
                                        <span>Manage Estimates</span>
                                      </button>
                                    </Col>
                                  </Row>
                                }
                              >
                                <Row justify="center">
                                  <Col>
                                    <span>
                                      There are no estimates at this time.
                                    </span>
                                  </Col>
                                </Row>
                              </CollpaseContainer>
                            </Col>
                            <Col span={24} className="col-container">
                              <p className="title">Vendor Trade</p>
                              <p>{item.vendorTrade}</p>
                            </Col>
                            <Col span={24} className="col-container">
                              <p className="title">Portal Uploaded Images</p>
                              {/* <div className="media-container">
                                {item.media.map((img, i) => {
                                  return <img src={img} alt="" key={i} />;
                                })}
                              </div> */}
                            </Col>
                            <Col span={24} className="col-container">
                              <p className="title">Vendor Instructions</p>
                              <p>{item.vendorInstructions}</p>
                            </Col>
                            <Col span={24}>
                              <CollpaseContainer title="Scheduling">
                                <Row gutter={[0, 16]}>
                                  <Col span={24}>
                                    <span>
                                      This work order has not been scheduled yet
                                    </span>
                                  </Col>
                                  <Col span={24}>
                                    <Row gutter={[0, 8]}>
                                      <Col span={24}>
                                        <p>Resident Availability</p>
                                      </Col>
                                      <Col span={24}>
                                        <Row className="header-Row">
                                          <Col span={12}>
                                            <span>Date</span>
                                          </Col>
                                          <Col span={12}>
                                            <span>Time</span>
                                          </Col>
                                        </Row>
                                        {/* {item.residentAvailability.map(
                                          (data, index) => {
                                            return (
                                              <Row
                                                className="data-Row"
                                                key={index}
                                              >
                                                <Col span={12}>
                                                  <span>{data.date}</span>
                                                </Col>
                                                <Col span={12}>
                                                  <span>{data.time}</span>
                                                </Col>
                                              </Row>
                                            );
                                          }
                                        )} */}
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </CollpaseContainer>
                            </Col>
                            <Col span={24}>{/* <ActionsLog />  */}</Col>
                            <Col span={24} className="col-container">
                              <p className="title">Assignee</p>
                              <p>
                                {item.assignee}{" "}
                                <span className="onclick-text">
                                  {" "}
                                  View as Maintenance Tech
                                </span>
                              </p>
                            </Col>
                            <Col span={24} className="col-container">
                              <p className="title">Labor</p>
                              <Row>
                                <Col className="header-col" span={10}>
                                  <span>Number</span>
                                </Col>
                                <Col className="header-col" span={3}>
                                  <span>Date</span>
                                </Col>
                                <Col className="header-col" span={3}>
                                  <span>Hours</span>
                                </Col>
                                <Col className="header-col" span={8}>
                                  <span>Description</span>
                                </Col>
                              </Row>
                              {item.labors.length > 0 ? (
                                item.labors.map((item) => {
                                  return (
                                    <Row>
                                      <Col className="data-Row" span={10}>
                                        <span>{item.maintenanceTech}</span>
                                      </Col>
                                      <Col className="data-Row" span={3}>
                                        <span>{item.date}</span>
                                      </Col>
                                      <Col className="data-Row" span={3}>
                                        <span>{item.hours}</span>
                                      </Col>
                                      <Col className="data-Row" span={8}>
                                        <span>{item.description}</span>
                                      </Col>
                                    </Row>
                                  );
                                })
                              ) : (
                                <Row justify="center">
                                  <Col>
                                    <span>Edit work order to add labor.</span>
                                  </Col>
                                </Row>
                              )}
                            </Col>
                            <Col span={24} className="col-container">
                              <Row justify="space-between">
                                <Col>
                                  <p className="title">Purchase Orders</p>
                                </Col>
                                <Col>
                                  <button>Add new purchase order</button>
                                </Col>
                              </Row>
                              <Row>
                                <Col className="header-col" span={6}>
                                  <span>Number</span>
                                </Col>
                                <Col className="header-col" span={4}>
                                  <span>Vendor</span>
                                </Col>
                                <Col className="header-col" span={4}>
                                  <span>Status</span>
                                </Col>
                                <Col className="header-col" span={5}>
                                  <span>PO Total</span>
                                </Col>
                                <Col className="header-col" span={5}>
                                  <span>PO Billed</span>
                                </Col>
                              </Row>
                              <Row justify="center">
                                <Col>
                                  <span>
                                    Add a new purchase order or edit work order
                                    to add an existing purchase order.
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24} className="col-container">
                              <p className="title">
                                Withheld Amount from Owner
                              </p>
                              <p>{item.withheldAmountfromOwner}</p>
                            </Col>
                            <Col span={24} className="col-container">
                              <p className="title">Invoices</p>
                              <Row>
                                <Col className="header-col" span={9}>
                                  <span>Invoice Name</span>
                                </Col>
                                <Col className="header-col" span={7}>
                                  <span>Submitted</span>
                                </Col>
                                <Col className="header-col" span={4}>
                                  <span>Vendor</span>
                                </Col>
                                <Col className="header-col" span={4}>
                                  <span>Amount</span>
                                </Col>
                              </Row>
                              <Row justify="center">
                                <Col>
                                  <span>
                                    No invoices have been submitted yet.
                                  </span>
                                </Col>
                              </Row>
                            </Col>
                            <Col span={24}>
                              <Texts />
                            </Col>
                            <Col span={24}>
                              <Emails />
                            </Col>
                            <Col span={24}>{/* <AttachmentsUpload /> */}</Col>
                          </Row>
                        </Col>
                      ) : (
                        item?.id === editId && (
                          <NewWorkOrder
                            setAddWorkOrder={setAddWorkOrder}
                            editId={editId}
                            data={itemData}
                            workOrderId={id}
                            workOrderNumber={workOrderNumber}
                            setCancelEdit={setEdit}
                          />
                        )
                      )}
                    </>
                  );
                })
              : null}
          </Row>
        </Col>
        {!addWorkOrder ? (
          <Col span={24}>
            <button className="add-btn" onClick={() => setAddWorkOrder(true)}>
              <MdOutlineAdd size={18} />
              <span>Add Work Order</span>
            </button>
          </Col>
        ) : null}
        {addWorkOrder ? (
          <Col span={24}>
            <NewWorkOrder
              setAddWorkOrder={setAddWorkOrder}
              workOrderId={id}
              property={property}
            />
          </Col>
        ) : null}
        <Col span={24}>{/* <Notes /> */}</Col>
      </Row>
      <div className="RightSidebar">
        <RightBar RightBarData={WorkOrderDetailsRightBar} />
      </div>
      {notifyOwner ? (
        <NotifyOwner
          setIsConfirmationBoxOpen={setNotifyOwner}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {notifyTenant ? (
        <NotifyTenant
          setIsConfirmationBoxOpen={setNotifyTenant}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {schedule ? (
        <Schedule
          setIsConfirmationBoxOpen={setSchedule}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {markJobDone ? (
        <MarkJobDone
          setIsConfirmationBoxOpen={setMarkJobDone}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {waiting ? (
        <Waiting
          setIsConfirmationBoxOpen={setWaiting}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {cancel ? (
        <Cancel
          setIsConfirmationBoxOpen={setCancel}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {isModalOpen ? (
        <CreateBill
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          workOrderNumber={workOrderNumber}
          data={vendor}
        />
      ) : null}
      {email ? (
        <Email
          setIsConfirmationBoxOpen={setEmail}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
      {estimatesRequest ? (
        <Email
          setIsConfirmationBoxOpen={setEstimatesRequest}
          workOrderNumber={workOrderNumber}
        />
      ) : null}
    </>
  );
}

export default WorkOrderDetails;
